import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col, Space } from 'antd';
import { DeleteForeverRounded, CompareArrowsRounded, CloseRounded } from "@mui/icons-material";
import Button from '@mui/material/Button';
import ButtonGroup from "@mui/material/ButtonGroup";
import Tooltip from '@mui/material/Tooltip';
import TickerChip from "../../../Components/TickerChip";
import ColoredItem from "../../../Components/ColoredItem";
import { debounce } from 'lodash';
import { InputNumber } from 'antd';

const PositionHeader = ({
  name,
  symbol,
  logoUrl,
  onRemove,
  onCheck,
  isChecked = false,
  color,
  holdingsCount,
  handleColorUpdate,
  handleWeightUpdate,
  weight // Add weight prop
}) => {
  const [localWeight, setLocalWeight] = useState(weight);

  // Use useCallback to memoize the debounced function
  const debouncedWeightUpdate = useCallback(debounce(handleWeightUpdate, 300), [handleWeightUpdate]);

  const handleWeightChange = (value) => {
    const newWeight = value * 0.01;
    setLocalWeight(newWeight);
    debouncedWeightUpdate(newWeight);
  };

  useEffect(() => {
    // Cleanup the debounce on unmount
    return () => {
      debouncedWeightUpdate.cancel();
    };
  }, [debouncedWeightUpdate]);

  const handleFocus = (event) => {
    if (event.target.value === '0' || event.target.value === '') {
      setLocalWeight('');
    }
  };

  return (
    <Row className={'pt-2'} justify="space-between" align="top" gutter={[2, 16]}>
      <Col span={24}>
        <Row justify="space-between" align="middle" wrap={false}>
          {/* ETF Title with Dropdown Menu */}
          <TickerChip ticker={{ logo: logoUrl, name, symbol }} titleSuffix={`(${holdingsCount})`} />
          <Space>
            <ColoredItem label={''} color={color} onUpdateColor={(color) => handleColorUpdate(color)} />
            <InputNumber
              value={localWeight * 100}
              onChange={handleWeightChange}
              onFocus={handleFocus}
              min={0}
              max={100}
              step={0.1}
              formatter={value => `${value}%`}
              parser={value => value.replace('%', '')}
              style={{ width: 60 }}
            />
            <ButtonGroup>
              <Tooltip title={isChecked ? 'Stop Comparing' : 'Compare Holdings to Other Etfs'}>
                <Button size={'small'} variant={isChecked ? 'contained' : 'text'} onClick={onCheck}>{isChecked ? <CloseRounded /> : <CompareArrowsRounded />}</Button>
              </Tooltip>
              <Button size={'small'} onClick={onRemove} variant={'text'} color="error"><DeleteForeverRounded /></Button>
            </ButtonGroup>
          </Space>
        </Row>
      </Col>
    </Row>
  );
};

export default PositionHeader;
